import { stringSchema, objectSchema } from '@/schemas'

export const reviewSchema = objectSchema({
  review: stringSchema.min(1),
})
